var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from 'mobx';
var Model = /** @class */ (function () {
    /**
     *
     * @param data
     */
    function Model(data) {
        if (data === void 0) { data = null; }
        this.initialize(data);
        this.update(data);
    }
    /**
     *
     * @param data
     */
    Model.prototype.initialize = function (data) {
    };
    /**
     *
     * @param data
     */
    Model.prototype.update = function (data) {
        var _this = this;
        if (!data)
            return;
        var keys = Object.keys(data);
        keys.map(function (key) {
            _this[key] = data[key];
        });
    };
    Object.defineProperty(Model.prototype, "filterString", {
        /**
         *
         * @return {string}
         */
        get: function () {
            var _this = this;
            var s = '';
            var keys = Object.keys(this);
            // Attributes
            keys.map(function (key) {
                s += _this[key] + '\n';
            });
            return s.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @return {*}
     */
    Model.prototype.toString = function () {
        var _this = this;
        // Class name
        var s = this.constructor.name;
        var keys = Object.keys(this);
        // Attributes
        keys.map(function (key) {
            s += '\n\t' + key + ': ' + _this[key];
        });
        return s;
    };
    __decorate([
        computed
    ], Model.prototype, "filterString", null);
    return Model;
}());
export default Model;
